export const styles = (theme: any) => ({
  dialogContainer: {
    backgroundColor: theme.ModalBGColor,
    padding: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column' as const
  },
  dialogContent: {
    padding: '0 16px 16px',
    display: 'flex',
    flexDirection: 'column' as const,
    flex: 1,
    minHeight: 0,
    overflow: 'hidden'
  },
  dialogFooter: {
    padding: '12px 16px',
    paddingRight: 100,
    display: 'flex',
    justifyContent: 'flex-end',
    flexShrink: 0
  },
  closeButtonFooter: {
    textTransform: 'none' as const,
    minWidth: 80
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    borderBottom: `1px solid ${theme.AppBGColor}`,
    backgroundColor: theme.ModalBGColor
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  headerTitle: {
    fontWeight: 600,
    fontSize: 16,
    color: theme.HeaderSelectedText
  },
  backButton: {
    padding: 4,
    color: theme.HeaderSelectedText,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  closeButton: {
    padding: 4,
    color: theme.iconColor,
    '&:hover': {
      color: theme.HeaderSelectedText
    }
  },
  gridsContainer: {
    display: 'flex',
    flexDirection: 'column' as const,
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    marginTop: 16,
    '& > *:not(:last-child)': {
      marginBottom: 16
    }
  },
  gridsContainerMaximized: {
    '& > *:not(:last-child)': {
      marginBottom: 0
    }
  },
  gridWrapper: {
    flex: '1 1 0',
    display: 'flex',
    flexDirection: 'column' as const,
    minHeight: 0
  },
  gridWrapperHidden: {
    display: 'none',
    flex: 0,
    height: 0
  },
  gridWrapperMaximized: {
    flex: '1 1 auto'
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: 200
  },
  errorContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: 200,
    color: theme.ErrorMessageColor
  }
});

export default styles;
